import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { extraServices } from '../data/extras';
import { SectionHeading } from './SectionHeading';
export function ExtraServices() {
  const {
    t
  } = useLanguage();
  return <section className="bg-mist" data-id="element-108" data-mp="17pe9rdohdhkw">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-109" data-mp="12wl6ku8nuhax">
        <SectionHeading kicker={t(copy.extrasKicker)} title={t(copy.extrasTitle)} subtitle={t(copy.extrasSubtitle)} data-id="element-110" data-mp="1gnzt3b1s10mq" />

        <ul className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4" data-id="element-111" data-mp="1cmek40sd56ht">
          {extraServices.map(extra => <li key={extra.id} className="flex flex-col rounded-2xl border border-navy/10 bg-white p-5" data-id="element-112" data-mp="1lncowlamli1g">
              <extra.icon className="h-6 w-6 text-royal" aria-hidden="true" data-id="element-113" data-mp="3sellca43tow6" />
              <h3 className="mt-4 font-display text-sm font-extrabold leading-snug text-navy" data-id="element-114" data-mp="3nf9362o6h5zx">
                {t(extra.label)}
              </h3>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-115" data-mp="1erzooczzli9u">
          <a href="#contact" className="inline-flex rounded-xl bg-royal px-6 py-3.5 font-display text-base font-bold text-white transition-colors duration-150 ease-out hover:bg-bright" data-id="element-116" data-mp="1esraiw3s81mx">
            {t(copy.navBook)}
          </a>
        </div>
      </div>
    </section>;
}